module.exports = __webpack_public_path__ + "img/hr-puberty-decal-05.9eb578ca.png";